<template>
  <v-app>
    <LeftNav @closeMenu="onMobileMenuBtnClick" :show-drawer="drawer"></LeftNav>
    <v-btn fab dark large color="primary" fixed left bottom @click="drawer = !drawer" v-if="showMobileMenuBtn">
      <v-icon dark>mdi-menu</v-icon>
    </v-btn>
    <v-app-bar
        app
        color="indigo"
        dense
        src="./assets/header-img.png"
    >

      <template v-slot:img="{ props }">
        <v-img
            v-bind="props"
        ></v-img>
      </template>
      <v-spacer></v-spacer>


      <v-btn icon to="/search">
        <v-icon color="brown darken-4" >mdi-magnify</v-icon>
      </v-btn>


    </v-app-bar>

    <v-main>
      <router-view @on-alert="onAlert($event)" id="scrolling-techniques"/>

      <v-snackbar
          app
          v-model="alert"
          :timeout="5000"
          :color="alertColor"
          bottom
      >
        {{ alertText }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="alert = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>

  </v-app>
</template>



<script>


import {REDDIT_LOG_URL} from "@/util/globalSettings";
import LeftNav from "@/components/common/LeftNav";

export default {
  name: 'App',
  components: {
    LeftNav

  },
  data: () => ({
    drawer: true,
    loginUrl: REDDIT_LOG_URL,
    alert: false,
    alertText: '',
    alertColor: 'info',
  }),
  mounted() {
    this.drawer = !this.showMobileMenuBtn;
  },
  created: function () {
    const vm = this;
    this.$redditApi.interceptors.response.use(undefined, function (err) {
      // eslint-disable-next-line no-unused-vars
      return new Promise(function (resolve, reject) {
        if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
          console.log('Intercepted 401')
          vm.$store.dispatch('logout', vm)
          .then(() => {
            vm.$router.push('/login')
          })
        }
        throw err;
      });
    });
  },
  methods: {

    onAlert(event) {
      this.alert = true;
      this.alertColor = event.color;
      this.alertText = event.message;
    },
    onMobileMenuBtnClick() {
      this.drawer = !this.drawer;
    },
  },

  computed: {
    showMobileMenuBtn() {
      console.log(this.$vuetify.breakpoint.name)
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
        default: return false
      }
    },
    maxWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 350
        case 'sm': return 350
        case 'md': return 500
        case 'lg': return 500
        case 'xl': return 500
        default: return 400
      }
    },
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn
    },
    getAvatarSrc: function () {
      return localStorage.getItem('avatar');
    },
  }
};
</script>

<style scoped>
.headertext {
  color: #000000;
  text-shadow: 2px 3px 2px #7A7A7A;
  font-weight: bold;


}
</style>
